/**
 * Homepage redesign: indice sezioni sticky (sezione attiva + scroll con offset),
 * count-up dei numeri ([data-countup]) al primo ingresso
 * in viewport e scroll morbido sull'ancora "Guarda gli ultimi risultati".
 * I valori finali sono già renderizzati server-side: senza JS (o con
 * prefers-reduced-motion attivo) restano semplicemente statici.
 */
(function () {
	'use strict';

	document.addEventListener('DOMContentLoaded', function () {
		var homepage = document.getElementById('homepage');
		if (!homepage) {
			return;
		}

		var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
		var locale = document.documentElement.lang || 'it';

		var nav = document.querySelector('.main-nav');
		var toc = homepage.querySelector('.home-toc');

		// L'header (main-nav.js) si nasconde scrollando giù e torna fisso scrollando su:
		// la barra indice si posiziona sotto di lui solo quando è visibile.
		function navOffset() {
			return nav && nav.classList.contains('sticky') ? nav.offsetHeight : 0;
		}

		// main-nav.js cambia la classe dentro il proprio handler di scroll: osserviamo
		// la classe invece di ascoltare lo scroll, così non dipendiamo dall'ordine degli handler.
		if (toc) {
			var syncTocTop = function () {
				toc.style.top = navOffset() + 'px';
			};
			if (nav && 'MutationObserver' in window) {
				new MutationObserver(syncTocTop).observe(nav, { attributes: true, attributeFilter: ['class'] });
			}
			syncTocTop();
		}

		// Scroll morbido verso le ancore interne (hero + indice) compensando le barre fisse.
		// Scrollando verso l'alto l'header ricompare, quindi va sommata anche la sua altezza.
		homepage.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
			var target = document.getElementById(anchor.getAttribute('href').slice(1));
			if (!target) {
				return;
			}
			anchor.addEventListener('click', function (e) {
				e.preventDefault();
				var y = target.getBoundingClientRect().top + window.pageYOffset;
				var goingUp = y < window.pageYOffset;
				var offset = (toc ? toc.offsetHeight : 0) + (goingUp && nav ? nav.offsetHeight : 0);
				window.scrollTo({ top: Math.max(y - offset, 0), behavior: reducedMotion ? 'auto' : 'smooth' });
				if (window.history && window.history.replaceState) {
					window.history.replaceState(null, '', '#' + target.id);
				}
			});
		});

		// Indice: evidenzia la sezione in lettura e, su mobile, porta la pill attiva
		// in vista scorrendo solo la lista (non la pagina).
		if (toc && 'IntersectionObserver' in window) {
			var list = toc.querySelector('.home-toc__list');
			var links = {};
			toc.querySelectorAll('.home-toc__link').forEach(function (a) {
				links[a.getAttribute('href').slice(1)] = a;
			});

			var setActive = function (id) {
				Object.keys(links).forEach(function (key) {
					var active = key === id;
					links[key].classList.toggle('is-active', active);
					if (active) {
						links[key].setAttribute('aria-current', 'true');
						if (list.scrollWidth > list.clientWidth) {
							var li = links[key].parentNode;
							list.scrollTo({ left: li.offsetLeft - 16, behavior: reducedMotion ? 'auto' : 'smooth' });
						}
					} else {
						links[key].removeAttribute('aria-current');
					}
				});
			};

			// Fascia di lettura: la sezione che attraversa la zona 35%-45% dell'altezza schermo
			var sectionObserver = new IntersectionObserver(function (entries) {
				entries.forEach(function (entry) {
					if (entry.isIntersecting) {
						setActive(entry.target.id);
					}
				});
			}, { rootMargin: '-35% 0px -55% 0px' });

			Object.keys(links).forEach(function (id) {
				var section = document.getElementById(id);
				if (section) {
					sectionObserver.observe(section);
				}
			});

			// Tornando sull'hero nessuna voce resta attiva
			var hero = homepage.querySelector('.home-hero');
			if (hero) {
				new IntersectionObserver(function (entries) {
					if (entries[0].intersectionRatio > 0.5) {
						setActive(null);
					}
				}, { threshold: [0.5] }).observe(hero);
			}
		}

		// Count-up
		var counters = homepage.querySelectorAll('[data-countup]');
		if (!counters.length || reducedMotion || !('IntersectionObserver' in window)) {
			return;
		}

		var DURATION = 1200;

		function animate(el) {
			var end = parseInt(el.getAttribute('data-countup'), 10);
			var suffix = el.getAttribute('data-suffix') || '';
			if (isNaN(end)) {
				return;
			}
			var start = null;

			function step(ts) {
				if (start === null) {
					start = ts;
				}
				var progress = Math.min((ts - start) / DURATION, 1);
				// easing out-cubic
				var eased = 1 - Math.pow(1 - progress, 3);
				var value = Math.round(end * eased);
				el.textContent = value.toLocaleString(locale) + (progress === 1 ? suffix : '');
				if (progress < 1) {
					window.requestAnimationFrame(step);
				}
			}

			window.requestAnimationFrame(step);
		}

		var observer = new IntersectionObserver(function (entries) {
			entries.forEach(function (entry) {
				if (entry.isIntersecting) {
					observer.unobserve(entry.target);
					animate(entry.target);
				}
			});
		}, { threshold: 0.4 });

		counters.forEach(function (el) {
			observer.observe(el);
		});
	});
})();
